import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  ExpansionPanel,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  TextField,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TrackingNumber from '../TrackingNumber';
import DollorsInput from '../DollorsInput';
import TrackingCourier from '../TrackingCourier';
import OrderCellMobile from '../OrderCellMobile';
import { orderDetails, products, address, valueFormat } from '../../common/constants';
import isMobile from 'ismobilejs';

const styles = theme => ({
  root: {
    padding: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexBasis: '80%',
    flexShrink: 0,
    color: '#FFFFFF',
  },
  expansionPanelSummary: {
    backgroundColor: '#4e91fd',
    height: 40,
  },
  expansionPanelDetails: {
    padding: 0,
  },
  expandMoreIcon: {
    color: '#FFFFFF',
    height: 30,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dialogContent: {
    padding: 5,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '200px',
    borderBottom: 0,
  },
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
});

class OrderDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: {
        details: true,
        shipping: true,
        products: true,
        tracking: true,
      },
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleClose = type => {
    this.props.handleClose();
  };

  handleChange = panel => {
    const currentExpanded = this.state.expanded;
    currentExpanded[panel] = !currentExpanded[panel];
    this.setState({
      expanded: currentExpanded,
    });
  };

  render() {
    const {
      orderInfo,
      classes,
      setTrackingNumber,
      setCourier,
      setShipmentCost,
      readOnly,
      carriers
    } = this.props;
    let currentOrder = {};
    if (orderInfo) {
      currentOrder = orderInfo;
    } else {
      this.handleClose();
    }
    const { expanded } = this.state;
    return (
      <div>
        <Dialog
          fullWidth
          maxWidth={false}
          open
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`OrderDetails ${
            currentOrder.shipmentRef ? `- ${currentOrder.shipmentRef}` : ''
          }`}</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <div className={classes.root}>
              <ExpansionPanel
                expanded={expanded.details}
                onChange={() => this.handleChange('details')}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}
                  className={classes.expansionPanelSummary}
                  style={{ minHeight: '40px' }}
                >
                  <Typography className={classes.heading} color="inherit">
                    Order Details:
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <form className={classes.container} noValidate autoComplete="off">
                    {orderDetails.map(
                      item =>
                        item.id === 'courier' ? (
                          <TrackingCourier
                            setCourier={setCourier}
                            trackingCourier={currentOrder[item.id]}
                            order={currentOrder}
                            withLabel
                            readOnly={readOnly}
                            carriers={carriers}
                          />
                        ) : item.id === 'trackingNumber' ? (
                          <TrackingNumber
                            setTrackingNumber={setTrackingNumber}
                            trackingNumber={currentOrder[item.id]}
                            order={currentOrder}
                            withLabel
                            readOnly={readOnly}
                          />
                        ) : item.id === 'supplierInputCost' ? (
                          <DollorsInput
                            setShipmentCost={setShipmentCost}
                            cost={currentOrder[item.id]}
                            order={currentOrder}
                            readOnly={readOnly}
                            withLabel
                            isDetailPage
                          />
                        ) : (
                          <TextField
                            key={`${item.id}`}
                            id={`${item.id}`}
                            label={item.label}
                            className={classes.textField}
                            value={valueFormat(item, currentOrder[item.id])}
                            margin="normal"
                            type="label"
                          />
                        )
                    )}
                  </form>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded.products}
                onChange={() => this.handleChange('products')}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}
                  className={classes.expansionPanelSummary}
                  style={{ minHeight: '40px' }}
                >
                  <Typography className={classes.heading}>Address:</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <form className={classes.container} noValidate autoComplete="off">
                    {address.map(item => (
                      <TextField
                        key={`${item.id}`}
                        id="name"
                        label={item.label}
                        className={classes.textField}
                        value={currentOrder[item.id] ? currentOrder[item.id] : ''}
                        margin="normal"
                        type="label"
                      />
                    ))}
                  </form>
                </ExpansionPanelDetails>
              </ExpansionPanel>

              <ExpansionPanel
                expanded={expanded.shipping}
                onChange={() => this.handleChange('shipping')}
              >
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon className={classes.expandMoreIcon} />}
                  className={classes.expansionPanelSummary}
                  style={{ minHeight: '40px' }}
                >
                  <Typography className={classes.heading}>Order Products:</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                  <div>
                    {isMobile.phone &&
                      currentOrder.products &&
                      currentOrder.products.map((product, index) => (
                        <OrderCellMobile
                          setTrackingNumber={setTrackingNumber}
                          setCourier={setCourier}
                          handleOnClick={this.handleOnClick}
                          order={product}
                          columnData={products}
                        />
                      ))}
                    {!isMobile.phone && (
                      <Table
                        className={classes.table}
                        aria-labelledby="ordersTable"
                        id="ordersTable"
                      >
                        <TableHead>
                          <TableRow>
                            {products.map(
                              column => (
                                <TableCell
                                  key={column.id}
                                  numeric={column.numeric}
                                  padding={column.disablePadding ? 'none' : 'default'}
                                >
                                  <TableSortLabel key={`label${column.id}`}>
                                    {column.label}
                                  </TableSortLabel>
                                </TableCell>
                              ),
                              this
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody name="mainBody">
                          {currentOrder.products &&
                            currentOrder.products.map((product, index) => (
                              <TableRow key={index}>
                                {products.map(item => (
                                  <TableCell
                                    key={`${item.id}`}
                                    style={{
                                      textAlign: item.numeric
                                        ? 'right'
                                        : !!item.date || !!item.datetime
                                          ? 'center'
                                          : 'left',

                                      fontWeight:
                                        item.id === 'quantity'
                                          ? product[item.id] * 100 > 900
                                            ? 900
                                            : product[item.id] * 100
                                          : 100,
                                    }}
                                  >
                                    {valueFormat(item, product[item.id])}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    )}
                  </div>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleClose('cancel')} className={classes.button}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

OrderDetails.propTypes = {
  orderInfo: PropTypes.object,
  classes: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  setTrackingNumber: PropTypes.func,
  setCourier: PropTypes.func,
  readOnly: PropTypes.boolean,
  carriers: PropTypes.array,
};

export default withStyles(styles)(OrderDetails);



// WEBPACK FOOTER //
// ./src/components/orders/orderDetails/index.js